import React from 'react';
import { Input } from 'antd';
import styled from '@emotion/styled';
interface IProps {
    minVal: number | null;
    maxVal: number | null;
    onMaxChange: (val: number) => void;
    onMinChange: (val: number) => void;
    parentClassName?: string;
    inputClassName?: string;
    placeHolder?: [string | undefined, string | undefined];
    disabled?: boolean;
}

const StyledInput = styled(Input)`
    width: 120px;
    height: 32px;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    appearance: textfield;
    border-radius: 0.375rem;
`;

const RangeInputCustom: React.FC<IProps> = ({
    minVal,
    maxVal,
    onMaxChange,
    onMinChange,
    parentClassName = '',
    inputClassName,
    placeHolder = ['Min', 'Max'],
    disabled = false,
}) => {
    const handleMinChange = (value: number | null) => {
        onMinChange(value as number);
    };

    const handleMaxChange = (value: number | null) => {
        onMaxChange(value as number);
    };

    return (
        <div className={`flex justify-between items-center ${parentClassName}`}>
            <StyledInput
                type="number"
                value={minVal || ''}
                onChange={(e) => handleMinChange(Number(e.target.value))}
                placeholder={placeHolder[0]}
                className={inputClassName}
                disabled={disabled}
            />
            -
            <StyledInput
                type="number"
                value={maxVal || ''}
                onChange={(e) => handleMaxChange(Number(e.target.value))}
                placeholder={placeHolder[1]}
                className={inputClassName}
                disabled={disabled}
            />
        </div>
    );
};

export default RangeInputCustom;
